<template>
    <div>
        <div class="smart-main-search-container flex flex-wrap">

            <div class="flex-1"></div>
            <div class="flex">
                <el-button type="primary" @click="add" plain>新增公司</el-button>
            </div>
            <!--<div class="flex">-->
                <!--<up    <!--<div class="flex">-->
            <!--<upload-button type="primary"  file-char="userFile" url="/smartMeter/file/importUsers" plain>导入人员</upload-button>-->
            <!--</div>-->
            <!--<div class="flex">-->
            <!--<upload-button type="primary"  file-char="userFile" url="/smartMeter/file/importPayLogs" plain>导入抄表记录</upload-button>-->
            <!--</div>load-button type="primary"  file-char="userFile" url="/smartMeter/file/importUsers" plain>导入人员</upload-button>-->
            <!--</div>-->
            <!--<div class="flex">-->
                <!--<upload-button type="primary"  file-char="userFile" url="/smartMeter/file/importPayLogs" plain>导入抄表记录</upload-button>-->
            <!--</div>-->

        </div>

        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
        <form-dialog ref="model" title="公司信息" @on-confirm="save">
            <div slot="dialog-main">
                <el-form>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="公司名称" label-width="160px">
                                <el-input v-model="temp.name"></el-input>
                            </el-form-item>
                        </div>


                    </div>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="管理员账号" label-width="160px">
                                <el-input v-model="temp.passport"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="管理员密码" label-width="160px">
                                <el-input v-model="temp.password"></el-input>
                            </el-form-item>
                        </div>


                    </div>


                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="开放平台应用ID(非公众号)：" label-width="160px">
                                <el-input v-model="temp.wxAppId"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="开放平台应用凭证(非公众号)：" label-width="160px">
                                <el-input v-model="temp.wxAppSecret"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="公众平台应用ID(公众号)：" label-width="160px">
                                <el-input v-model="temp.wxPublicAppId"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="公众平台应用凭证(公众号)：" label-width="160px">
                                <el-input v-model="temp.wxPublicAppSecret"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="商户号" label-width="160px">
                                <el-input v-model="temp.wxMchId"></el-input>
                            </el-form-item>
                        </div>


                    </div>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="管应用对应的密钥" label-width="160px">
                                <el-input v-model="temp.wxAppKey"></el-input>
                            </el-form-item>
                        </div>


                    </div>





                </el-form>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import UploadButton from "../../components/UploadButton";
    export default{
        components: {
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton,
            UploadButton
        },
        data(){
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label:'编辑',fn:this.getDetail}
                ],
                labels: [
                    {prop: 'name', label: '公司名称'},
                    {prop: 'passport', label: '账号'},

                ],
                temp:{}
            }
        },
        computed:{
            list(){
                let  arr = []
                for(var i in this.$store.state.tasKeyMap){
                    arr.push({id:i,name:this.$store.state.tasKeyMap[i]})
                }
                return arr
            },
        },
        mounted(){
            this.getList()
        },
        methods: {
            search(stop){
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page){
                this.searchParams.page = page
                this.getList()
            },
            getList(callback){
                this.$http$({method: 'get', url: "/smartMeter/company",data:this.searchParams,  load: 1}, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            getDetail(obj){
                this.temp = JSON.parse(JSON.stringify(obj))
                this.$refs.model.show()
            },
            add(){
                this.temp = {}
                this.$refs.model.show()
            },

            save(){
                this.temp.rate1 = this.temp.step1
                let method = 'post',url='/smartMeter/company',msg = '新增公司成功！'
                if(this.temp.id){
                    method = "put"
                    // url = '/smartMeterServer/price/update'
                    msg = '修改公司信息成功！'
                }
                this.$http$({method:method,url:url,data:this.temp},(data) => {
                    this.getList()
                    this.$success(msg)
                })

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/superAdmin/company.vue